import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Editor, Toolbar, Validators } from 'ngx-editor';
import { DeliveryService } from '../services/delivery.service';




@Component({
  selector: 'app-notepad',
  templateUrl: './notepad.component.html',
  styleUrls: ['./notepad.component.scss']
})
export class NotepadComponent implements OnInit {

  form: FormGroup;

  constructor(public dialogRef: MatDialogRef<NotepadComponent>, private deliveryservice: DeliveryService) {
    this.editor = new Editor();

    this.form = new FormGroup({
      editorContent: new FormControl(
        { value: "", disabled: false },
        Validators.required()
      ),
    });
  }

  closeP() {
    let data = this.form.get('editorContent').value;
    this.dialogRef.close({ notepaddata: data });


  }

  editor: Editor;
  defaultnotepaddata: string;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['text_color', 'background_color'],
    ['link', 'image'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];



  get doc(): AbstractControl {
    return this.form.get('editorContent');
  }

  ngOnInit(): void {
    this.deliveryservice.notepaddevalue$.subscribe((data: any) => {
      this.defaultnotepaddata = data;
      this.form.get('editorContent').setValue(data);
    })

    this.dialogRef.backdropClick().subscribe(() => {
      let data = this.form.get('editorContent').value;

      this.deliveryservice.notepaddevalue$.next(data);
      this.dialogRef.close();
    })
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

}
